exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "@charset \"UTF-8\"\n", "",{"version":3,"sources":["variables.scss"],"names":[],"mappings":"AAAA,eAAgB","file":"variables.scss","sourcesContent":["@charset \"UTF-8\";\n:export {\n  font-path: \"../fonts\";\n  border-radius: 2px;\n  scale-base: 12px;\n  scale-base-up-01: 13px;\n  scale-base-up-02: 15px;\n  scale-base-up-03: 18px;\n  scale-base-up-04: 20px;\n  scale-base-up-05: 27px;\n  scale-base-up-06: 30px;\n  scale-base-up-07: 40px;\n  scale-base-up-08: 45px;\n  scale-base-up-09: 60px;\n  scale-base-up-10: 90px;\n  scale-base-down-01: 9px;\n  scale-base-down-02: 6px;\n  scale-base-down-03: 3px;\n  sg-blue: #1a82e2;\n  slate: #294661;\n  sg-blue-80: #489be8;\n  sg-blue-60: #76b4ee;\n  sg-blue-40: #a3cdf3;\n  sg-blue-20: #d1e6f9;\n  sg-blue-10: #e8f2fc;\n  sg-blue-05: #f3f9fd;\n  sg-blue-02: #fbfdff;\n  slate-80: #546b81;\n  slate-60: #7f90a0;\n  slate-40: #a9b5c0;\n  slate-20: #d4dadf;\n  slate-10: #e9ecef;\n  slate-05: #f4f6f7;\n  slate-02: #fbfbfc;\n  logo-accent-light: #99e1f4;\n  logo-accent-medium: #00b3e3;\n  logo-accent-dark: #009dd9;\n  ron-burgundy: #b71c1c;\n  burnt-orange: #ff5722;\n  carrot: #f90;\n  mango: #fdd835;\n  mantis: #18c96e;\n  spruce: #4cb04f;\n  grass-stain: #8ac24a;\n  lime: #cbdb39;\n  cobalt: #303f9f;\n  bluebird: #2196f3;\n  seafoam: #00bcd4;\n  caribbean: #00e5ff;\n  crown: #7b1fa2;\n  screample: #7c4dff;\n  sangria: #880e4f;\n  lavender: #dea7e8;\n  wild-strawberry: #ff4081;\n  steel: #9e9e9e;\n  white: #fff;\n  black: #000;\n  color-highlighter: rgba(253, 216, 53, 0.6);\n  sg-blue-dark: #71ade4;\n  slate-40-dark: #9aa6b1;\n  ron-burgundy-dark: #ff5c5c;\n  burnt-orange-dark: #e87a5a;\n  carrot-dark: #e8a644;\n  mango-dark: #e3cc64;\n  light-gray-dark: #7c8b98;\n  steel-dark: #b9b9b9;\n  caribbean-dark: #00cee6;\n  color-highlighter-dark: #3b4958;\n  active-line-dark: #1f2b39;\n  copy-button-dark: #284462;\n  alert-success: #f1f7e9;\n  alert-success-text: #2e6b30;\n  alert-warning: #fefae6;\n  alert-warning-text: #8c6c15;\n  alert-danger: #f4dddd;\n  alert-danger-text: #b71c1c;\n  alert-verification: #18c96e;\n  alert-trial: #294661;\n  btn-primary-bg: #489be8;\n  btn-primary-bg-hover: #1a82e2;\n  btn-primary-border: #1a82e2;\n  btn-primary-color: #fff;\n  btn-primary-badge-bg: #fff;\n  btn-primary-badge-color: #1a82e2;\n  btn-secondary-bg: #fff;\n  btn-secondary-bg-hover: #e8f2fc;\n  btn-secondary-border: #489be8;\n  btn-secondary-color: #1a82e2;\n  btn-secondary-badge-bg: #1a82e2;\n  btn-secondary-badge-color: #fff;\n  btn-danger-bg: rgba(183, 28, 28, 0.8);\n  btn-danger-bg-hover: #b71c1c;\n  btn-danger-border: #b71c1c;\n  btn-danger-color: #fff;\n  btn-danger-badge-bg: #fff;\n  btn-danger-badge-color: #b71c1c;\n  btn-dark-bg: transparent;\n  btn-dark-bg-hover: rgba(255, 255, 255, 0.1);\n  btn-dark-border: rgba(255, 255, 255, 0.6);\n  btn-dark-color: #fff;\n  btn-dark-badge-bg: #fff;\n  btn-dark-badge-color: #294661;\n  btn-disabled-bg: #9e9e9e;\n  btn-disabled-border: #9e9e9e;\n  btn-disabled-color: #fff;\n  btn-disabled-secondary-bg: #fff;\n  btn-disabled-secondary-border: #9e9e9e;\n  btn-disabled-secondary-color: #9e9e9e;\n  btn-gear-color: #7f90a0;\n  btn-gear-primary-color: #fff;\n  btn-group-bg: #fff;\n  btn-group-bg-hover: rgba(26, 130, 226, 0.1);\n  btn-group-bg-active: #489be8;\n  btn-group-border: rgba(26, 130, 226, 0.8);\n  btn-group-border-active: #1a82e2;\n  btn-group-color: #1a82e2;\n  btn-group-color-active: #fff;\n  btn-selectable-border: #d4dadf;\n  btn-selectable-border-hover: #a3cdf3;\n  btn-selectable-border-active: #1a82e2;\n  btn-selectable-color: #546b81;\n  center-modal-bg: #fff;\n  center-modal-width: 600px;\n  center-modal-position: -300px;\n  dropzone-bg: #fbfbfc;\n  dropzone-border: #d4dadf;\n  dropzone-bg-active: #f4f6f7;\n  dropzone-border-active: #7f90a0;\n  dropzone-hovered-bg: #e7f9f0;\n  dropzone-hovered-border: #18c96e;\n  segment-term-max-width: 768px;\n  icon-ab-testing: \"\";\n  icon-ad-campaign: \"\";\n  icon-airplane-fill: \"\";\n  icon-airplane: \"\";\n  icon-align-center: \"\";\n  icon-align-left: \"\";\n  icon-align-right: \"\";\n  icon-analytics: \"\";\n  icon-automation: \"\";\n  icon-briefcase: \"\";\n  icon-builder: \"\";\n  icon-button: \"\";\n  icon-calendar: \"\";\n  icon-caret: \"\";\n  icon-chat: \"\";\n  icon-check-circle: \"\";\n  icon-check-shield: \"\";\n  icon-check-thin: \"\";\n  icon-check: \"\";\n  icon-clean-ui: \"\";\n  icon-clear-formatting: \"\";\n  icon-click: \"\";\n  icon-clock: \"\";\n  icon-code: \"\";\n  icon-columns: \"\";\n  icon-connection: \"\";\n  icon-contacts-alt: \"\";\n  icon-contacts: \"\";\n  icon-copy: \"\";\n  icon-create: \"\";\n  icon-csv: \"\";\n  icon-desktop-view: \"\";\n  icon-divider: \"\";\n  icon-download: \"\";\n  icon-drag: \"\";\n  icon-dual-flags: \"\";\n  icon-editor-code: \"\";\n  icon-editor-design: \"\";\n  icon-editor-old: \"\";\n  icon-ellipsis-vertical: \"\";\n  icon-ellipsis: \"\";\n  icon-export: \"\";\n  icon-filter: \"\";\n  icon-forms: \"\";\n  icon-frequency-optimization: \"\";\n  icon-gear: \"\";\n  icon-hash: \"\";\n  icon-help: \"\";\n  icon-image-text: \"\";\n  icon-image: \"\";\n  icon-images: \"\";\n  icon-info-circle: \"\";\n  icon-key: \"\";\n  icon-list: \"\";\n  icon-locked: \"\";\n  icon-mail-multi: \"\";\n  icon-mail-search: \"\";\n  icon-mail: \"\";\n  icon-mobile-view: \"\";\n  icon-pencil: \"\";\n  icon-people: \"\";\n  icon-pie-chart: \"\";\n  icon-plus: \"\";\n  icon-push-notifications: \"\";\n  icon-recipient-cpm: \"\";\n  icon-reload: \"\";\n  icon-save-draft: \"\";\n  icon-search: \"\";\n  icon-segment: \"\";\n  icon-send-optimization: \"\";\n  icon-sequence-optimization: \"\";\n  icon-settings: \"\";\n  icon-social: \"\";\n  icon-sort-asc: \"\";\n  icon-sort-desc: \"\";\n  icon-spacer: \"\";\n  icon-status-caution: \"\";\n  icon-status-negative: \"\";\n  icon-status-positive: \"\";\n  icon-teammate: \"\";\n  icon-test-data: \"\";\n  icon-text-only: \"\";\n  icon-text: \"\";\n  icon-trash: \"\";\n  icon-unlocked: \"\";\n  icon-unsubscribe: \"\";\n  icon-user-security: \"\";\n  icon-view: \"\";\n  icon-warning-triangle: \"\";\n  icon-warning: \"\";\n  icon-x-legacy: \"\";\n  icon-x: \"\";\n  loader-dark-light: rgba(255, 255, 255, 0.35);\n  loader-dark-medium: rgba(255, 255, 255, 0.75);\n  loader-dark-medium-solid: rgba(255, 255, 255, 0.9);\n  loader-dark-solid: #fff;\n  modal-bg: rgba(0, 0, 0, 0.5);\n  modal-width: 525px;\n  modal-height: 665px;\n  modal-footer-height: 71px;\n  modal-body-height: 594px;\n  modal-z-index: 20000;\n  side-modal-shadow: -2px 0 6px rgba(41, 70, 97, 0.1);\n  select-disabled-color: rgba(158, 158, 158, 0.4);\n  select2-disabled-border: rgba(158, 158, 158, 0.4);\n  select2-disabled-placeholder: rgba(158, 158, 158, 0.4);\n  select2-disabled-arrow: rgba(158, 158, 158, 0.4);\n  switch-background-z-index: 10;\n  switch-selector-z-index: 11;\n  switch-option-z-index: 12;\n  stats-delivered: #8ac24a;\n  stats-opens: #303f9f;\n  stats-unique-opens: #2196f3;\n  stats-clicks: #7b1fa2;\n  stats-unique-clicks: #7c4dff;\n  stats-unsubscribes: #880e4f;\n  stats-spam-reports: #b71c1c;\n  compare-border-color: #e9ecef;\n  text-input-disabled-border: rgba(158, 158, 158, 0.4);\n  text-input-disabled-color: rgba(158, 158, 158, 0.4);\n  text-input-search-title-bg: rgba(26, 130, 226, 0.1);\n  text-area-disabled-border: rgba(158, 158, 158, 0.4);\n  text-area-disabled-color: rgba(158, 158, 158, 0.4);\n  tooltip-bg: #294661;\n  tooltip-font-size: 12px;\n  tooltip-line-height: 18px;\n  tooltip-arrow-height: 6px;\n  dropdown-menu-z-index: 1000;\n  spotlight-circle-z-index: 10000;\n  spotlight-tooltip-z-index: 10010;\n  info-popup-z-index: 19000; }\n"]}]);
// Exports
exports.locals = {
	"font-path": "\"../fonts\"",
	"border-radius": "2px",
	"scale-base": "12px",
	"scale-base-up-01": "13px",
	"scale-base-up-02": "15px",
	"scale-base-up-03": "18px",
	"scale-base-up-04": "20px",
	"scale-base-up-05": "27px",
	"scale-base-up-06": "30px",
	"scale-base-up-07": "40px",
	"scale-base-up-08": "45px",
	"scale-base-up-09": "60px",
	"scale-base-up-10": "90px",
	"scale-base-down-01": "9px",
	"scale-base-down-02": "6px",
	"scale-base-down-03": "3px",
	"sg-blue": "#1a82e2",
	"slate": "#294661",
	"sg-blue-80": "#489be8",
	"sg-blue-60": "#76b4ee",
	"sg-blue-40": "#a3cdf3",
	"sg-blue-20": "#d1e6f9",
	"sg-blue-10": "#e8f2fc",
	"sg-blue-05": "#f3f9fd",
	"sg-blue-02": "#fbfdff",
	"slate-80": "#546b81",
	"slate-60": "#7f90a0",
	"slate-40": "#a9b5c0",
	"slate-20": "#d4dadf",
	"slate-10": "#e9ecef",
	"slate-05": "#f4f6f7",
	"slate-02": "#fbfbfc",
	"logo-accent-light": "#99e1f4",
	"logo-accent-medium": "#00b3e3",
	"logo-accent-dark": "#009dd9",
	"ron-burgundy": "#b71c1c",
	"burnt-orange": "#ff5722",
	"carrot": "#f90",
	"mango": "#fdd835",
	"mantis": "#18c96e",
	"spruce": "#4cb04f",
	"grass-stain": "#8ac24a",
	"lime": "#cbdb39",
	"cobalt": "#303f9f",
	"bluebird": "#2196f3",
	"seafoam": "#00bcd4",
	"caribbean": "#00e5ff",
	"crown": "#7b1fa2",
	"screample": "#7c4dff",
	"sangria": "#880e4f",
	"lavender": "#dea7e8",
	"wild-strawberry": "#ff4081",
	"steel": "#9e9e9e",
	"white": "#fff",
	"black": "#000",
	"color-highlighter": "rgba(253, 216, 53, 0.6)",
	"sg-blue-dark": "#71ade4",
	"slate-40-dark": "#9aa6b1",
	"ron-burgundy-dark": "#ff5c5c",
	"burnt-orange-dark": "#e87a5a",
	"carrot-dark": "#e8a644",
	"mango-dark": "#e3cc64",
	"light-gray-dark": "#7c8b98",
	"steel-dark": "#b9b9b9",
	"caribbean-dark": "#00cee6",
	"color-highlighter-dark": "#3b4958",
	"active-line-dark": "#1f2b39",
	"copy-button-dark": "#284462",
	"alert-success": "#f1f7e9",
	"alert-success-text": "#2e6b30",
	"alert-warning": "#fefae6",
	"alert-warning-text": "#8c6c15",
	"alert-danger": "#f4dddd",
	"alert-danger-text": "#b71c1c",
	"alert-verification": "#18c96e",
	"alert-trial": "#294661",
	"btn-primary-bg": "#489be8",
	"btn-primary-bg-hover": "#1a82e2",
	"btn-primary-border": "#1a82e2",
	"btn-primary-color": "#fff",
	"btn-primary-badge-bg": "#fff",
	"btn-primary-badge-color": "#1a82e2",
	"btn-secondary-bg": "#fff",
	"btn-secondary-bg-hover": "#e8f2fc",
	"btn-secondary-border": "#489be8",
	"btn-secondary-color": "#1a82e2",
	"btn-secondary-badge-bg": "#1a82e2",
	"btn-secondary-badge-color": "#fff",
	"btn-danger-bg": "rgba(183, 28, 28, 0.8)",
	"btn-danger-bg-hover": "#b71c1c",
	"btn-danger-border": "#b71c1c",
	"btn-danger-color": "#fff",
	"btn-danger-badge-bg": "#fff",
	"btn-danger-badge-color": "#b71c1c",
	"btn-dark-bg": "transparent",
	"btn-dark-bg-hover": "rgba(255, 255, 255, 0.1)",
	"btn-dark-border": "rgba(255, 255, 255, 0.6)",
	"btn-dark-color": "#fff",
	"btn-dark-badge-bg": "#fff",
	"btn-dark-badge-color": "#294661",
	"btn-disabled-bg": "#9e9e9e",
	"btn-disabled-border": "#9e9e9e",
	"btn-disabled-color": "#fff",
	"btn-disabled-secondary-bg": "#fff",
	"btn-disabled-secondary-border": "#9e9e9e",
	"btn-disabled-secondary-color": "#9e9e9e",
	"btn-gear-color": "#7f90a0",
	"btn-gear-primary-color": "#fff",
	"btn-group-bg": "#fff",
	"btn-group-bg-hover": "rgba(26, 130, 226, 0.1)",
	"btn-group-bg-active": "#489be8",
	"btn-group-border": "rgba(26, 130, 226, 0.8)",
	"btn-group-border-active": "#1a82e2",
	"btn-group-color": "#1a82e2",
	"btn-group-color-active": "#fff",
	"btn-selectable-border": "#d4dadf",
	"btn-selectable-border-hover": "#a3cdf3",
	"btn-selectable-border-active": "#1a82e2",
	"btn-selectable-color": "#546b81",
	"center-modal-bg": "#fff",
	"center-modal-width": "600px",
	"center-modal-position": "-300px",
	"dropzone-bg": "#fbfbfc",
	"dropzone-border": "#d4dadf",
	"dropzone-bg-active": "#f4f6f7",
	"dropzone-border-active": "#7f90a0",
	"dropzone-hovered-bg": "#e7f9f0",
	"dropzone-hovered-border": "#18c96e",
	"segment-term-max-width": "768px",
	"icon-ab-testing": "\"\"",
	"icon-ad-campaign": "\"\"",
	"icon-airplane-fill": "\"\"",
	"icon-airplane": "\"\"",
	"icon-align-center": "\"\"",
	"icon-align-left": "\"\"",
	"icon-align-right": "\"\"",
	"icon-analytics": "\"\"",
	"icon-automation": "\"\"",
	"icon-briefcase": "\"\"",
	"icon-builder": "\"\"",
	"icon-button": "\"\"",
	"icon-calendar": "\"\"",
	"icon-caret": "\"\"",
	"icon-chat": "\"\"",
	"icon-check-circle": "\"\"",
	"icon-check-shield": "\"\"",
	"icon-check-thin": "\"\"",
	"icon-check": "\"\"",
	"icon-clean-ui": "\"\"",
	"icon-clear-formatting": "\"\"",
	"icon-click": "\"\"",
	"icon-clock": "\"\"",
	"icon-code": "\"\"",
	"icon-columns": "\"\"",
	"icon-connection": "\"\"",
	"icon-contacts-alt": "\"\"",
	"icon-contacts": "\"\"",
	"icon-copy": "\"\"",
	"icon-create": "\"\"",
	"icon-csv": "\"\"",
	"icon-desktop-view": "\"\"",
	"icon-divider": "\"\"",
	"icon-download": "\"\"",
	"icon-drag": "\"\"",
	"icon-dual-flags": "\"\"",
	"icon-editor-code": "\"\"",
	"icon-editor-design": "\"\"",
	"icon-editor-old": "\"\"",
	"icon-ellipsis-vertical": "\"\"",
	"icon-ellipsis": "\"\"",
	"icon-export": "\"\"",
	"icon-filter": "\"\"",
	"icon-forms": "\"\"",
	"icon-frequency-optimization": "\"\"",
	"icon-gear": "\"\"",
	"icon-hash": "\"\"",
	"icon-help": "\"\"",
	"icon-image-text": "\"\"",
	"icon-image": "\"\"",
	"icon-images": "\"\"",
	"icon-info-circle": "\"\"",
	"icon-key": "\"\"",
	"icon-list": "\"\"",
	"icon-locked": "\"\"",
	"icon-mail-multi": "\"\"",
	"icon-mail-search": "\"\"",
	"icon-mail": "\"\"",
	"icon-mobile-view": "\"\"",
	"icon-pencil": "\"\"",
	"icon-people": "\"\"",
	"icon-pie-chart": "\"\"",
	"icon-plus": "\"\"",
	"icon-push-notifications": "\"\"",
	"icon-recipient-cpm": "\"\"",
	"icon-reload": "\"\"",
	"icon-save-draft": "\"\"",
	"icon-search": "\"\"",
	"icon-segment": "\"\"",
	"icon-send-optimization": "\"\"",
	"icon-sequence-optimization": "\"\"",
	"icon-settings": "\"\"",
	"icon-social": "\"\"",
	"icon-sort-asc": "\"\"",
	"icon-sort-desc": "\"\"",
	"icon-spacer": "\"\"",
	"icon-status-caution": "\"\"",
	"icon-status-negative": "\"\"",
	"icon-status-positive": "\"\"",
	"icon-teammate": "\"\"",
	"icon-test-data": "\"\"",
	"icon-text-only": "\"\"",
	"icon-text": "\"\"",
	"icon-trash": "\"\"",
	"icon-unlocked": "\"\"",
	"icon-unsubscribe": "\"\"",
	"icon-user-security": "\"\"",
	"icon-view": "\"\"",
	"icon-warning-triangle": "\"\"",
	"icon-warning": "\"\"",
	"icon-x-legacy": "\"\"",
	"icon-x": "\"\"",
	"loader-dark-light": "rgba(255, 255, 255, 0.35)",
	"loader-dark-medium": "rgba(255, 255, 255, 0.75)",
	"loader-dark-medium-solid": "rgba(255, 255, 255, 0.9)",
	"loader-dark-solid": "#fff",
	"modal-bg": "rgba(0, 0, 0, 0.5)",
	"modal-width": "525px",
	"modal-height": "665px",
	"modal-footer-height": "71px",
	"modal-body-height": "594px",
	"modal-z-index": "20000",
	"side-modal-shadow": "-2px 0 6px rgba(41, 70, 97, 0.1)",
	"select-disabled-color": "rgba(158, 158, 158, 0.4)",
	"select2-disabled-border": "rgba(158, 158, 158, 0.4)",
	"select2-disabled-placeholder": "rgba(158, 158, 158, 0.4)",
	"select2-disabled-arrow": "rgba(158, 158, 158, 0.4)",
	"switch-background-z-index": "10",
	"switch-selector-z-index": "11",
	"switch-option-z-index": "12",
	"stats-delivered": "#8ac24a",
	"stats-opens": "#303f9f",
	"stats-unique-opens": "#2196f3",
	"stats-clicks": "#7b1fa2",
	"stats-unique-clicks": "#7c4dff",
	"stats-unsubscribes": "#880e4f",
	"stats-spam-reports": "#b71c1c",
	"compare-border-color": "#e9ecef",
	"text-input-disabled-border": "rgba(158, 158, 158, 0.4)",
	"text-input-disabled-color": "rgba(158, 158, 158, 0.4)",
	"text-input-search-title-bg": "rgba(26, 130, 226, 0.1)",
	"text-area-disabled-border": "rgba(158, 158, 158, 0.4)",
	"text-area-disabled-color": "rgba(158, 158, 158, 0.4)",
	"tooltip-bg": "#294661",
	"tooltip-font-size": "12px",
	"tooltip-line-height": "18px",
	"tooltip-arrow-height": "6px",
	"dropdown-menu-z-index": "1000",
	"spotlight-circle-z-index": "10000",
	"spotlight-tooltip-z-index": "10010",
	"info-popup-z-index": "19000"
};